import { UserRole } from '../../../enums';
import { initialSchoolConfigProps } from '../types';

const initialSchoolConfigData: initialSchoolConfigProps = {
  school: '',
  isOnboarded: true,
  orgCode: '',
  studentEmaildDomain: '',
  timezoneDetails: {
    offset: 300,
    timezone: 'IST'
  },
  notificationsSchedule: {
    instraSiteNotes: '15:00'
  },
  featureConfigs: {
    postModeration: {
      enabled: false,
      skipFor: []
    },
    ensureId: {
      enabled: false,
      metaData: {
        deleteAuthorisedPersonLink: ''
      }
    },
    studentRollover: {
      enabled: false,
      metaData: {
        skipPaymentFlowAfterRollover: false,
        skipReview: false
      }
    },
    allowParentToPostToSubjectTeacher: {
      enabled: false
    },
    sendModerationMessagesToChatwoot: {
      enabled: false
    },
    allowBossesToViewPosts: {
      enabled: false
    },
    blsAttendanceTracker: {
      enabled: false
    },
    showStellarPaymentPostText: {
      enabled: false
    },
    sendFirstPaymentPostForNewAdmissions: {
      enabled: false
    },
    alertsForBusLeavingFromSchool: {
      enabled: false
    },
    alertsForBusReachingSchool: {
      enabled: false
    },

    importantDocs: {
      enabled: false
    },
    attendanceTracking: {
      enabled: false
    },
    busTracking: {
      enabled: false
    },

    studentsMarksTracker: {
      enabled: false
    },
    multiselectVisbilityGroups: {
      enabled: false
    },
    notesExplorer: {
      enabled: false
    },
    dailyClassUpdate: {
      enabled: false
    },
    removePostOption: {
      enabled: false
    },
    reportPostOption: {
      enabled: false
    },
    reportUserOption: {
      enabled: false
    },
    reportCommentOption: {
      enabled: false
    },
    edutainFeed: {
      enabled: false
    },
    enlightFeed: {
      enabled: false
    },
    childEther: {
      enabled: false
    },
    staffAttendance: { enabled: false },
    photoIdCards: {
      enabled: false
    }
  },
  welcomeEmailNotificationsConfig: {
    admissionOfferValidityDays: '',
    brandName: '',
    brandSignOffLine: '',
    fullFeeConcession: '',
    knowlarityNumber: '',
    schoolFullName: ''
  },
  featureNotificationRecipients: {
    ReportPost: {
      emailIds: [],
      notificationType: {
        email: false,
        onDeck: false,
        push: false
      }
    }
  },
  userCustomFieldMapping: {},
  roleFeaturesMapping: [],
  crmToEtherGradeMappings: [],
  functionalUserEmails: {
    accountsEmail: '',
    grooveHqEmailId: '',
    originalPosterForPaymentPosts: {},
    otpBccEmailId: '',
    retoolUser: '',
    welcomeEmailId: ''
  },
  parentsPostPublishAccess: {
    CLASS_TEACHERS: {
      allowedRoles: [],
      isEnabled: false
    },
    CLASS_TEACHERS_AND_SCHOOL_OFFICE: {
      isEnabled: false,
      allowedRoles: []
    },
    INDIVIDUAL: {
      allowedRoles: [],
      isEnabled: false
    }
  }
};

const newRoleMapping = {
  role: '',
  features: {
    publishDcu: {
      enabled: false
    },
    addRemarksDcu: {
      enabled: false
    }
  }
};

const newSchool = {
  grades: [],
  emailIds: [],
  contacts: [],
  address: '',
  website: '',
  name: 'New School',
  branding: {
    studentIdCard: {
      backgroundColor: '',
      textColor: '',
      fontName: '',
      logo: null
    },
    parentIdCard: {
      backgroundColor: '',
      textColor: '',
      fontName: '',
      logo: null
    },
    guardianIdCard: {
      backgroundColor: '',
      textColor: '',
      fontName: '',
      logo: null
    },
    studentLC: {
      lcHeadingColor: '',
      pipeColor: '',
      schoolNameColor: '',
      schoolLogo: null,
      watermark: null,
      fontName: ''
    },
    dailyClassUpdate: {
      schoolLogo: null
    }
  },
  udiseNo: '',
  affiliationNo: ''
};

const rolesExcludedForParentsPostPublish: UserRole[] = [
  UserRole.CURRENT_STUDENT,
  UserRole.CURRENT_PARENT,
  UserRole.ADMIN,
  UserRole.NURSE,
  UserRole.MODERATOR,
  UserRole.CONTENT_CREATOR,
  UserRole.CENTRAL_ACADEMIC_TEAM,
  UserRole.ETHER_BOT,
  UserRole.ETHER_EVENTS_BOT,
  UserRole.SUPER_ADMIN,
  UserRole.EX_PARENT,
  UserRole.EX_STUDENT,
  UserRole.COUNSELLOR,
  UserRole.SECTION_CHIEF,
  UserRole.GUEST
];

const fontNames = [
  {
    value: 'Satoshi',
    label: 'Satoshi'
  },
  {
    value: 'Myriad Pro Regular',
    label: 'Myriad Pro Regular'
  },
  {
    value: 'Myriad Pro Regular',
    label: 'Myriad Pro Regular'
  },
  {
    value: 'Myriad Pro',
    label: 'Myriad Pro'
  },
  {
    value: 'Lato',
    label: 'Lato'
  },
  {
    value: 'Satoshi Regular',
    label: 'Satoshi Regular'
  }
];

const defaultEnabledFeatureConfigs = [
  'attendanceTracking',
  'busTracking',
  'studentsMarksTracker',
  'dailyClassUpdate',
  'reportPostOption',
  'reportUserOption',
  'reportCommentOption'
];

const defaultDisabledFeatureConfigs = [
  'notesExplorer',
  'edutainFeed',
  'enlightFeed',
  'showStellarPaymentPostText'
];

export {
  initialSchoolConfigData,
  rolesExcludedForParentsPostPublish,
  newRoleMapping,
  newSchool,
  fontNames,
  defaultEnabledFeatureConfigs,
  defaultDisabledFeatureConfigs
};
